import { render, staticRenderFns } from "./ContentViewSettingsAccess.vue?vue&type=template&id=6dafdfc9&scoped=true&"
import script from "./ContentViewSettingsAccess.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dafdfc9",
  null
  
)

export default component.exports